import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {SimpleGallery} from "../../SimpleGallery";
import {getProjectByPath} from "../../../db/projectStore";
import {Col, Row} from "react-bootstrap";

const AdditionalDates = (additionalPlays) => {
  return (
    <div className="additional-dates">
      <p className="fs-5 mt-5">Weitere Spieltermine:</p>
      {
        additionalPlays.map((play, index) => (
          <span key={index} className='d-block'><strong>{play.date}</strong> {play.location}</span>
        ))
      }
    </div>
  );
};

export const ProjectDetailPage = () => {
  const { projectPath } = useParams()
  const project = getProjectByPath(projectPath)
  const [galleryData, setGalleryData] = useState([]);
  
  useEffect(() => {
    const loadGalleryData = async () => {
      try {
        // Dynamically import the JSON file based on the projectPath
        const data = (await import(`../../../images/${projectPath}/${projectPath}.json`)).default;
        const formattedData = data.map(image => ({
          src: require(`../../../images/${projectPath}/${image.src}`), // Dynamically require the image
          width: image.width,
          height: image.height,
        }));
        setGalleryData(formattedData);
      } catch (error) {
        console.error("Error loading gallery data:", error);
      }
    };
    
    loadGalleryData().catch(error => console.log(error));
  }, [projectPath]);

  return (
    <div>
      <h1>{project.title}</h1>
      <p> {project.caption}</p>
      <Row>
        <Col xs={12} md={6} className="fs-4 fw-light">
          {project.description}
        </Col>
        <Col xs={12} md={6}>
          <iframe width="100%" height="100%" src={project.youtubeTrailer}
                  title="YouTube video player" frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen></iframe>
        </Col>
      </Row>
      {project.cast &&
        <Row>
          <Col xs={12} lg={7} className="mb-5">
            <p className='fs-5 mt-5'>Cast & Credits</p>
            <p className='fs-5 mt-5'>
              {
                project.cast.map((item, index) => (
                  <span key={index} className='d-block'>{item.role}:<strong> {item.names} </strong></span>
                ))
              }
            </p>
          </Col>
          { project.premiere &&
            <Col xs={12} lg={5} className="mb-5">
              <p className='fs-5 mt-5'>Premiere</p>
              <p className='fs-5 mt-5'>
                {project.premiere.date} - {project.premiere.location}
              </p>
              {project.additionalDates && AdditionalDates(project.additionalDates)}
            </Col>
            
          }
        </Row>
      }
      <SimpleGallery images={galleryData}/>
    </div>
  )
}